import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Separator from './Separator';
import NavMenuItem from './NavMenuItem';
import MenuItem from './MenuItem';

const StyledMenu = styled.ul`
  list-style: none;
  margin: 0;
  padding: 10px;
`;

const defaultRender = data => {
  const { splitter, path, ...props } = data;

  if (splitter) {
    return (
      <Separator
        paddingLeft="small"
        paddingRight="small"
        color="background400"
      />
    );
  }
  if (path) {
    return <NavMenuItem path={path} {...props} />;
  }
  return <MenuItem {...props} />;
};

const Menu = ({ data, render, ...props }) => (
  <StyledMenu {...props}>
    {data.map((d, index) => (
      <li key={d.key}>{render(d, index)}</li>
    ))}
  </StyledMenu>
);

Menu.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  render: PropTypes.func,
};

Menu.defaultProps = {
  data: [],
  render: defaultRender,
};

export default Menu;
